/* eslint-disable react/prop-types */
import styles from './styles.module.css'

export const PackageOptionList = ({ title, options = [], onSelect }) => {
  if (!options.length) return null

  return (
    <div className={styles.optionList}>
      {title && <p className={styles.optionListTitle}>{title}</p>}
      {options.map((option, index) => (
        <button
          key={option.id ?? `${option.label}-${index}`}
          type="button"
          className={styles.optionItem}
          onClick={() => (option.onClick ?? onSelect)?.(option, index)}
        >
          <span className={styles.optionItemLabel}>{option.label}</span>
          <span className={styles.optionItemPrice}>{option.price}</span>
        </button>
      ))}
    </div>
  )
}

export default PackageOptionList
